// Set a cookie with the gclid query parameter
function setGclidCookie() {
  let urlParams = new URLSearchParams(window.location.search);
  let gclid = urlParams.get('gclid');
  if (gclid) {
    document.cookie = "gclid=" + encodeURIComponent(gclid) + ";path=/";
  }
}

// Get the gclid value from the cookie
function getGclidFromCookie() {
  let name = "gclid=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookieArray = decodedCookie.split(';');
  for(let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}

// Append the gclid value to a link
function appendGclidToLink(link) {
  let gclid = getGclidFromCookie();
  if (gclid) {
    link.href += (link.href.includes('?') ? '&' : '?') + 'gclid=' + gclid;
  }
}
// Append the gclid value to links with href="www.test.com/*" when clicked
document.addEventListener('click', function(event) {
  let target = event.target;
  while (target && target.tagName !== 'A') {
    target = target.parentNode;
  }
  if (target && target.href.includes('join.vooks.com')) {
    appendGclidToLink(target);
  }
});

// Set the cookie on page load
document.addEventListener("DOMContentLoaded", function(event) {
  setGclidCookie();
});
